var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-flex",
    [
      _c("v-combobox", {
        attrs: {
          dense: "",
          "error-messages": _vm.computedErrors,
          "item-text": "name",
          "item-value": "value",
          items: _vm.items,
          label: _vm.label,
          placeholder: _vm.placeholder,
          chips: "",
          multiple: "",
          "return-object": ""
        },
        on: { blur: _vm.handleBlur },
        scopedSlots: _vm._u([
          {
            key: "selection",
            fn: function(ref) {
              var item = ref.item
              var parent = ref.parent
              return [
                _c(
                  "v-chip",
                  {
                    on: {
                      click: function(e) {
                        return e.stopPropagation()
                      }
                    }
                  },
                  [
                    _c("span", [_vm._v(_vm._s(item.name))]),
                    _vm._v(" "),
                    _c(
                      "v-icon",
                      {
                        staticClass: "close-icon",
                        attrs: { small: "" },
                        on: {
                          click: function($event) {
                            return _vm.handleRemoveItem(item)
                          }
                        }
                      },
                      [_vm._v("mdi-close-circle")]
                    )
                  ],
                  1
                )
              ]
            }
          }
        ]),
        model: {
          value: _vm.computedModel,
          callback: function($$v) {
            _vm.computedModel = $$v
          },
          expression: "computedModel"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-444c7d5f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-444c7d5f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/checkbox-list-2.vue
// module id = null
// module chunks = 